module.exports = __webpack_public_path__ + "media/images/flags/AG-6abac37c8d6ff685c5f9ec59830a16de.svg";